import script from "./GlobalSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSnackbar.vue?vue&type=style&index=0&id=2cdc3759&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdc3759"]])

export default __exports__